// extracted by mini-css-extract-plugin
module.exports = {"container":"LogosCarousel_container__o8JLo","swiper":"LogosCarousel_swiper__2WgkY","slide":"LogosCarousel_slide__21MYg"};